

import { Component, Vue } from 'vue-property-decorator'
import {
    ClassifiersService,
    authenticationStore
} from '@/store'
import AppHeader from '@/commons/components/page/AppHeader.vue'
import ModalBoxError from '@/commons/components/modal-box/ModalBoxError.vue'
import ModalBoxTimeoutWarning from '@/commons/components/modal-box/ModalBoxTimeoutWarning.vue'
import CookieNotification from '@/commons/components/cookie-notification/CookieNotification.vue'

@Component({
    components: {
        ModalBoxTimeoutWarning,
        ModalBoxError,
        AppHeader,
        CookieNotification
    }
})
export default class App extends Vue {
    created (): void {
        this.fetchClassifiers()
    }

    updated (): void {
        this.fetchClassifiers()
    }

    fetchClassifiers (): void {
        if (authenticationStore.isAuthenticated) {
            ClassifiersService.fetchClassifiers()
        }
    }
}
